import React, { Component } from "react";
import { Link } from "react-router-dom";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";
import moment from "moment";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
} from "react-bootstrap";

const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  approval_by: "Approver",
};

class FileManagement extends Component {
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
  };

  reportWillDeleteObj = null;

  componentDidMount() {
    this.getUploadManagement();
  }

  getUploadManagement = () => {
    Http.getUploadManagement(Business.COMPONENT.ICAAP, null).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (element && element.file_name.startsWith("ICAAP")) {
            element.timestamp = new Date(element.upload_time).getTime();
            listData.push(element);
          }
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        this.setState({
          items: listData,
          loading: false,
        });
      }
    });
  };

  search = () => {
    const objSearch = {
      report_date:
        this.state.searchOption === "report_date"
          ? this.state.searchValue
          : null,
      file_name:
        this.state.searchOption === "file_name" ? this.state.searchValue : null,
      approval_by:
        this.state.searchOption === "approval_by"
          ? this.state.searchValue
          : null,
    };

    Http.getUploadManagement(Business.COMPONENT.ICAAP, objSearch).then(
      (data) => {
        if (data && data.Success) {
          let listData = [];
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (element && element.file_name.startsWith("ICAAP")) {
              element.timestamp = new Date(element.upload_time).getTime();
              listData.push(element);
            }
          }
          listData = listData.sort((a, b) => {
            return b.timestamp - a.timestamp;
          });
          this.setState({
            items: listData,
            loading: false,
          });
        }
      },
    );
  };

  deleteListItems = () => {
    Http.deleteListReport(
      Business.COMPONENT.ICAAP,
      this.reportWillDeleteObj,
    ).then((res) => {
      if (res.Success) {
        this.getUploadManagement();
      }
    });
    this.reportWillDeleteObj = null;
  };

  onDelete = (reportName, reportDate) => {
    this.reportWillDeleteObj = {
      file_name: reportName,
      report_date: reportDate,
    };
    this.setState({
      showDeleteAlert: true,
    });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_VIEW_REPORT]) && (
        <div className="card">
          <div className="header">
            <h4 className="title">File Management</h4>
          </div>
          <div className="content table-full-width">
            <div className="ey-search-bar">
              <DropdownButton
                title={dicSearchOptions[this.state.searchOption]}
                bsSize="small"
                id={`dropdown-size-${1}`}
              >
                <MenuItem
                  onSelect={(eventKey, event) => {
                    this.setState({ searchOption: eventKey });
                  }}
                  eventKey={`report_date`}
                >
                  {"Report Date"}
                </MenuItem>
                <MenuItem divider />
                <MenuItem
                  onSelect={(eventKey, event) => {
                    this.setState({ searchOption: eventKey });
                  }}
                  eventKey={`file_name`}
                >
                  {"Report Name"}
                </MenuItem>
                <MenuItem divider />
                <MenuItem
                  onSelect={(eventKey, event) => {
                    this.setState({ searchOption: eventKey });
                  }}
                  eventKey={`approval_by`}
                >
                  {"Approver"}
                </MenuItem>
                <MenuItem divider />
              </DropdownButton>
              <input
                type="text"
                className="form-control ey-search-input"
                id="search_value"
                onChange={(event) => {
                  this.setState({ searchValue: event.target.value });
                }}
              />
              <button
                type="button"
                disabled={this.state.progressValue > 0}
                className="btn btn-primary ey-search-btn"
                onClick={() => this.search()}
              >
                Search
              </button>
            </div>
            <div style={{ height: 15 }} />
            <div style={{}}>
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>Report Date</th>
                    <th>Report Name</th>
                    <th>Action</th>
                    <th>Uploader</th>
                    <th>Upload Time</th>
                    <th>Approver</th>
                    <th>Approval Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.items.map((item) => (
                    <tr key={item.file_name}>
                      <td>{Business.convertToDate(item.report_date)}</td>
                      <td>
                        <Link
                          to={{
                            pathname: `/icaap/file-info/${Business.convertToDate(item.report_date)}/${item.file_name}`,
                            state: item,
                          }}
                          style={{ color: "blue" }}
                        >
                          {`${item.file_name}`.substring("ICAAP_".length)}
                        </Link>
                      </td>
                      <td>{Business.convertUploadType(item.upload_type)}</td>
                      <td>{item.upload_by}</td>
                      <td>{Business.convertToFullDate(item.upload_time)}</td>
                      <td>{item.approval_by}</td>
                      <td>{Business.convertToFullDate(item.approval_time)}</td>
                      <td>{Business.convertFileStatus(item.status)}</td>
                      <td className="text-right">
                        {Business.isHasRole([
                          Business.ROLE_DEFINE_MAP.ICAAP_DELETE_REPORT,
                        ]) ? (
                          <a
                            rel="tooltip"
                            aria-disabled="true"
                            className="btn btn-info btn-simple btn-xs"
                            data-original-title="View Profile"
                            onClick={() =>
                              this.onDelete(item.file_name, item.report_date)
                            }
                          >
                            <i
                              style={{ fontSize: 23, color: "red" }}
                              className="pe-7s-trash"
                            ></i>
                          </a>
                        ) : (
                          <div></div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Alert
            title="Are you sure?"
            show={this.state.showDeleteAlert}
            text="You will not be able to recover this report!"
            showCancelButton
            onConfirm={() => {
              this.setState({ showDeleteAlert: false });
              this.deleteListItems();
            }}
            onCancel={() => {
              this.setState({ showDeleteAlert: false });
              this.reportWillDeleteObj = null;
            }}
          />
        </div>
      )
    );
  }
}

export default FileManagement;



// WEBPACK FOOTER //
// src/pages/ICAAP/FileManagement/FileManagement.js